export default __webpack_public_path__ + "img/snowroad2.df7a5eb9.png";